import axios from "axios";

import { TTP_API_URL } from "../config";

export const getOrder = (token, orderId) => {
  const filter = [{ property: "id", value: orderId, operator: "eq" }];
  const fields = ["*", "invoice"];

  const requestUrl = `${TTP_API_URL}/billing/order`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      fields: fields.join(","),
    },
  });
};

export const getOrderDetails = (token, orderId) => {
  const filter = [
    { property: "documentId", value: orderId, operator: "eq" },
    { property: "documentType", value: "ORDER", operator: "eq" },
  ];

  const fields = ["*"];

  const requestUrl = `${TTP_API_URL}/billing/document_lines`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      fields: fields.join(","),
    },
  });
};

export const displayDocument = (token, documentId, type) => {
  const requestUrl =
    TTP_API_URL +
    `/billing/order/documentDisplay/` +
    type.toLowerCase() +
    `/` +
    documentId;

  window.open(requestUrl + `?access_token=` + token, "_blank");
};

export const billingCancelSubscription = (token, subscriptionId) => {
  const requestUrl = `${TTP_API_URL}/billing/subscription/cancel-subscription`;
  const data = {
    access_token: token,
    subscriptionId,
  };

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("subscriptionId", subscriptionId);

  return axios.post(requestUrl, formData);
};

export const getInvoices = ({ token, filters }) => {
  const requestUrl = `${TTP_API_URL}/billing/order`;

  const fields = ["*", "invoice", "assignments", "creditNotes"];
  const filter = [
    { property: "client", value: filters.organization, operator: "eq" },
    // { property: "user", value: filters.user, operator: "eq" },
    { property: "appType", value: ["site_builder"], operator: "in" },
    { property: "isCanceled", value: 0, operator: "eq" },
    { property: "status", value: ["PAID", "OVER_PAID"], operator: "in" },
    { property: "documentDate", value: filters.documentDate, operator: "in" },
  ];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      fields: fields.join(","),
      sort: JSON.stringify([
        {
          property: "documentDate",
          dir: "DESC",
        },
      ]),
      start: filters.page ? (filters.page - 1) * filters.limit : 0,
      limit: filters.limit,
    },
  });
};
